<script>
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import BaseButtonElement from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import { mapState } from "pinia";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { EVENT_TYPE_LIVESTREAM } from "%/constants/event-constants";
import { getJoinTarget } from "%/utils/event-join-target";

export default {
  name: "EventMeetingLink",
  elementPanelSettings: {
    displayName: "Event Meeting Link",
    displayIcon: "hyperlink",
    elementType: "element",
    elementGroup: "eventElements",
  },
  extends: BaseButtonElement,
  mixins: [EventCardElementMixin],
  computed: {
    ...mapState(useGeneralStore, ["links"]),
    isLivestream() {
      return this.entity.eventType === EVENT_TYPE_LIVESTREAM;
    },
    defaultLabel() {
      return "Join Meeting";
    },
    joinTarget() {
      return getJoinTarget(
        { eventId: this.entity.id, meetingLink: this.entity.meetingLink, isLivestream: this.isLivestream },
        this.links.web,
      );
    },
    textOptionValue() {
      const customText = this.getOptionValue(this.textValueOptionClass);
      if (customText?.body_text && customText.body_text !== "\n") {
        return customText;
      }
      return { body_text: this.defaultLabel, ranges: [] };
    },
  },
  methods: {
    handleButtonClick() {
      if (this.editMode || this.inBuilderEditScope) {
        return;
      }

      const { href, opensNewTab } = this.joinTarget;

      if (opensNewTab) {
        window.open(href, "_blank", "noopener,noreferrer");
        return;
      }

      window.location.href = href;
    },
  },
};
</script>
